import { type RefObject, useEffect, useState } from "react";

export const useFirstStepHeight = (
  contentRef: RefObject<HTMLDivElement>,
  sets: Array<unknown>,
) => {
  const [firstStepHeight, setFirstStepHeight] = useState(0);
  useEffect(() => {
    if (!contentRef.current) return;
    const content = contentRef.current as HTMLElement;
    const points = content.querySelectorAll(".combo-narrator__content__step");
    const pointEl = points[0];
    if (!pointEl) return;

    const setWrapper = pointEl.querySelector(".setInnerWrapper");
    if (!setWrapper) return;
    const { height } = setWrapper.getBoundingClientRect();
    setFirstStepHeight(height);
  }, [sets, contentRef]);

  return firstStepHeight;
};
